import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  enable() {
    this.submitButtonTarget.classList.remove("disable")
    this.submitButtonTarget.innerHTML = "Submit essay"
  }

  disable() {
    this.submitButtonTarget.classList.add("disable")
    this.submitButtonTarget.innerHTML = "Autosaving..."
  }
}
